import { setErrorReducer, setRequestReducer, setSuccessReducer } from '../helper';
import actions from './actions';

const initialState = {
    providers: [],
    providersReadAllState: false,
    connectOauth2State: false,
    // connectHttpState: false,

    // STREAMS
    streams: [],
    streamsPagination: null,
    streamsReadAllState: false,

    stream: null,
    streamReadState: false,
    streamMappings: {
        locations: [],
        tax_codes: [],
        payment_methods: [],
        fee_mappings: [],

        locations_are_required: null,
        tax_codes_are_required: null,
        payment_methods_are_required: null,
        fee_mappings_are_required: null,

        locations_allow_update: null,
        tax_codes_allow_update: null,
        payment_methods_allow_update: null,
        fee_mappings_allow_update: null,
    },
    streamMappingReadState: false,

    createHttpStreamState: false,
    createHttpStreamResult: null,

    updateStreamState: false,
    updateStreamMappingState: false,

    syncStreamState: false,

    deactivateStreamState: false,
    activateStreamState: false,
    deleteStreamState: false,

    // DIGESTS
    digests: [],
    digestsPagination: null,
    digestsReadAllState: false,
    lastDigestsReadAllRequest: {}, // to be used after eg bulk delete digests, to fetch the new batch of digests

    digestDeleteState: false,
    digestsBulkDeleteState: false,

    digestBulkPostingState: false,

    digestPostToInvoiceState: false,
    postedDigestInvoice: null,

    digestSummaryReadState: false,
    digestSummary: {},

    digestItemsReadState: false,
    digestItems: [],
    digestItemsPagination: null,

    digestOrdersReadState: false,
    digestOrders: [],
    digestOrdersPagination: null,

    digestOrderItemsReadState: false,
    // Separate each orderId's items instead of putting it in one arr digestOrderItems=[],
    // to prevent when multiple order collapse is opened, all render the same table.
    digestOrderItems: {
        // [orderId]: items
    },
    digestOrderIdBeingRead: null,
};

export default function appReducer(state = initialState, action = {}) {
    switch (action.type) {
        /** PROVIDERS */
        // Read providers
        case actions.FLOW_READ_ALL_PROVIDERS_REQUEST:
            return setRequestReducer(state, 'providersReadAllState');
        case actions.FLOW_READ_ALL_PROVIDERS_SUCCESS: {
            return setSuccessReducer(state, 'providersReadAllState', {
                // ...state,
                providers: action.providers,
            });
        }
        case actions.FLOW_READ_ALL_PROVIDERS_ERROR:
            return setErrorReducer(state, 'providersReadAllState');

        // Connect OAUTH2
        case actions.FLOW_CONNECT_OAUTH2_REQUEST:
            return setRequestReducer(state, 'connectOauth2State');
        case actions.FLOW_CONNECT_OAUTH2_SUCCESS:
            return setSuccessReducer(state, 'connectOauth2State');
        case actions.FLOW_CONNECT_OAUTH2_ERROR:
            return setErrorReducer(state, 'connectOauth2State');

            // Connect HTTP
            // case actions.FLOW_CONNECT_HTTP_REQUEST:
            //     return setRequestReducer(state, 'connectHttpState');
            // case actions.FLOW_CONNECT_HTTP_SUCCESS:
            //     return setSuccessReducer(state, 'connectHttpState', {
            //         ...state,
            //         // createHttpStreamResult: action.stream,
            //     });
            // case actions.FLOW_CONNECT_HTTP_ERROR:
            //     return setRequestReducer(state, 'connectHttpState');

        /** STREAMS */
        case actions.FLOW_READ_ALL_STREAMS_REQUEST:
            return setRequestReducer(state, 'streamsReadAllState');
        case actions.FLOW_READ_ALL_STREAMS_SUCCESS: {
            return setSuccessReducer(state, 'streamsReadAllState', {
                // ...state,
                streams: action.streams,
                streamsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        }
        case actions.FLOW_READ_ALL_STREAMS_ERROR:
            return setErrorReducer(state, 'streamsReadAllState');

        case actions.FLOW_READ_STREAM_REQUEST:
            return setRequestReducer(state, 'streamReadState');
        case actions.FLOW_READ_STREAM_SUCCESS:
            return setSuccessReducer(state, 'streamReadState', {
                // ...state,
                stream: action.stream,
            });
        case actions.FLOW_READ_STREAM_ERROR:
            return setErrorReducer(state, 'streamReadState');

        case actions.FLOW_READ_STREAM_MAPPING_REQUEST:
            return setRequestReducer(state, 'streamMappingReadState');
        case actions.FLOW_READ_STREAM_MAPPING_SUCCESS:

            return setSuccessReducer(state, 'streamMappingReadState', {
                // ...state,
                streamMappings: action.mappings,
            });
        case actions.FLOW_READ_STREAM_MAPPING_ERROR:
            return setErrorReducer(state, 'streamMappingReadState');

        case actions.FLOW_CREATE_HTTP_STREAM_REQUEST:
            return setRequestReducer(state, 'createHttpStreamState');
        case actions.FLOW_CREATE_HTTP_STREAM_SUCCESS:
            return setSuccessReducer(state, 'createHttpStreamState', {
                // ...state,
                createHttpStreamResult: action.stream,
            });
        case actions.FLOW_CREATE_HTTP_STREAM_ERROR:
            return setErrorReducer(state, 'createHttpStreamState');

        case actions.FLOW_UPDATE_STREAM_REQUEST:
            return setRequestReducer(state, 'updateStreamState');
        case actions.FLOW_UPDATE_STREAM_SUCCESS:
            return setSuccessReducer(state, 'updateStreamState', {
                // ...state,
                stream: action.stream,
            });
        case actions.FLOW_UPDATE_STREAM_ERROR:
            return setErrorReducer(state, 'updateStreamState');

        case actions.FLOW_UPDATE_STREAM_MAPPINGS_REQUEST:
            return setRequestReducer(state, 'updateStreamMappingState');
        case actions.FLOW_UPDATE_STREAM_MAPPINGS_SUCCESS:
            return setSuccessReducer(state, 'updateStreamMappingState', {
                streamMappings: action.mappingData,
            });
        case actions.FLOW_UPDATE_STREAM_MAPPINGS_ERROR:
            return setErrorReducer(state, 'updateStreamMappingState');

        case actions.FLOW_SYNCHRONIZE_STREAM_REQUEST:
            return setRequestReducer(state, 'syncStreamState');
        case actions.FLOW_SYNCHRONIZE_STREAM_SUCCESS:
            return setSuccessReducer(state, 'syncStreamState');
        case actions.FLOW_SYNCHRONIZE_STREAM_ERROR:
            return setErrorReducer(state, 'syncStreamState');

        case actions.FLOW_DEACTIVATE_STREAM_REQUEST:
            return setRequestReducer(state, 'deactivateStreamState');
        case actions.FLOW_DEACTIVATE_STREAM_SUCCESS:
            return setSuccessReducer(state, 'deactivateStreamState');
        case actions.FLOW_DEACTIVATE_STREAM_ERROR:
            return setErrorReducer(state, 'deactivateStreamState');

        case actions.FLOW_ACTIVATE_STREAM_REQUEST:
            return setRequestReducer(state, 'activateStreamState');
        case actions.FLOW_ACTIVATE_STREAM_SUCCESS:
            return setSuccessReducer(state, 'activateStreamState');
        case actions.FLOW_ACTIVATE_STREAM_ERROR:
            return setErrorReducer(state, 'activateStreamState');

        case actions.FLOW_DELETE_STREAM_REQUEST:
            return setRequestReducer(state, 'deleteStreamState');
        case actions.FLOW_DELETE_STREAM_SUCCESS:
            return setSuccessReducer(state, 'deleteStreamState');
        case actions.FLOW_DELETE_STREAM_ERROR:
            return setErrorReducer(state, 'deleteStreamState');

        /** DIGESTS */
        case actions.FLOW_READ_ALL_DIGESTS_REQUEST:
            return setRequestReducer(state, 'digestsReadAllState');
        case actions.FLOW_READ_ALL_DIGESTS_SUCCESS: {
            return setSuccessReducer(state, 'digestsReadAllState', {
                // ...state,
                digests: action.digests,
                digestsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastDigestsReadAllRequest: action.request,
            });
        }
        case actions.FLOW_READ_ALL_DIGESTS_ERROR:
            return setErrorReducer(state, 'digestsReadAllState');

        case actions.FLOW_DELETE_DIGEST_REQUEST:
            return setRequestReducer(state, 'digestDeleteState');
        case actions.FLOW_DELETE_DIGEST_SUCCESS:
            return setSuccessReducer(state, 'digestDeleteState');
        case actions.FLOW_DELETE_DIGEST_ERROR:
            return setErrorReducer(state, 'digestDeleteState');

        case actions.FLOW_BULK_DELETE_DIGESTS_REQUEST:
            return setRequestReducer(state, 'digestsBulkDeleteState');
        case actions.FLOW_BULK_DELETE_DIGESTS_SUCCESS:
            return setSuccessReducer(state, 'digestsBulkDeleteState');
        case actions.FLOW_BULK_DELETE_DIGESTS_ERROR:
            return setErrorReducer(state, 'digestsBulkDeleteState');

        case actions.FLOW_BULK_POSTING_REQUEST:
            return setRequestReducer(state, 'digestBulkPostingState');
        case actions.FLOW_BULK_POSTING_SUCCESS:
            return setSuccessReducer(state, 'digestBulkPostingState');
        case actions.FLOW_BULK_POSTING_ERROR:
            return setErrorReducer(state, 'digestBulkPostingState');

        case actions.FLOW_POST_DIGEST_TO_INVOICE_REQUEST:
            return setRequestReducer(state, 'digestPostToInvoiceState');
        case actions.FLOW_POST_DIGEST_TO_INVOICE_SUCCESS: {
            return setSuccessReducer(state, 'digestPostToInvoiceState', {
                // ...state,
                postedDigestInvoice: action.postedDigestInvoice,
            });
        }
        case actions.FLOW_POST_DIGEST_TO_INVOICE_ERROR:
            return setErrorReducer(state, 'digestPostToInvoiceState');

        // DIGEST SUMMARY, ITEMS, ORDERS
        // Summary
        case actions.FLOW_READ_DIGEST_SUMMARY_REQUEST:
            return setRequestReducer(state, 'digestSummaryReadState');
        case actions.FLOW_READ_DIGEST_SUMMARY_SUCCESS: {
            return setSuccessReducer(state, 'digestSummaryReadState', {
                // ...state,
                digestSummary: action.digestSummary,
            });
        }
        case actions.FLOW_READ_DIGEST_SUMMARY_ERROR:
            return setErrorReducer(state, 'digestSummaryReadState');

        // Items
        case actions.FLOW_READ_DIGEST_ITEMS_REQUEST:
            return setRequestReducer(state, 'digestItemsReadState');
        case actions.FLOW_READ_DIGEST_ITEMS_SUCCESS: {
            return setSuccessReducer(state, 'digestItemsReadState', {
                // ...state,
                digestItems: action.digestItems,
                digestItemsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        }
        case actions.FLOW_READ_DIGEST_ITEMS_ERROR:
            return setErrorReducer(state, 'digestItemsReadState');

        // Orders
        case actions.FLOW_READ_DIGEST_ORDERS_REQUEST:
            return setRequestReducer(state, 'digestOrdersReadState');
        case actions.FLOW_READ_DIGEST_ORDERS_SUCCESS: {
            return setSuccessReducer(state, 'digestOrdersReadState', {
                // ...state,
                digestOrders: action.digestOrders,
                digestOrdersPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        }
        case actions.FLOW_READ_DIGEST_ORDERS_ERROR:
            return setErrorReducer(state, 'digestOrdersReadState');

        // Order Items
        case actions.FLOW_READ_DIGEST_ORDER_ITEMS_REQUEST:
            return setRequestReducer(state, 'digestOrderItemsReadState', {
                // ...state,
                digestOrderIdBeingRead: action.orderId,
                digestOrderItems: {
                    ...state.digestOrderItems,
                    [action.orderId]: [],
                },
            });
        case actions.FLOW_READ_DIGEST_ORDER_ITEMS_SUCCESS: {
            return setSuccessReducer(state, 'digestOrderItemsReadState', {
                // ...state,
                digestOrderItems: {
                    ...state.digestOrderItems,
                    [action.orderId]: action.digestOrderItems,
                },
            });
        }
        case actions.FLOW_READ_DIGEST_ORDER_ITEMS_ERROR:
            return setErrorReducer(state, 'digestOrderItemsReadState');

        case actions.FLOW_RESET_DIGEST:
            return {
                ...state,
                digestOrderItems: {},
                digestOrderIdBeingRead: null,
                digestOrders: [],
                digestOrdersPagination: null,
                digestItems: [],
                digestItemsPagination: null,
                digestSummary: {},
                postedDigestInvoice: null,
            };

        default:
            return state;
    }
}
